"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _emotion = require("emotion");

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var actions = _interopRequireWildcard(require("../editorActions"));

var shapes = _interopRequireWildcard(require("../shapes"));

var utils = _interopRequireWildcard(require("../utils"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  outline: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var containerStyle = (0, _emotion.css)(_templateObject());

function isPrintable(event) {
  var keyCode = event.keyCode,
      altKey = event.altKey,
      ctrlKey = event.ctrlKey,
      metaKey = event.metaKey;
  var spaceKey = keyCode === 32;
  var equalKey = keyCode === 61; // Firefox only

  var numberKey = keyCode >= 48 && keyCode <= 57;
  var letterKey = keyCode >= 65 && keyCode <= 90;
  var numPadKey = keyCode >= 96 && keyCode <= 112;
  var latin1Key = keyCode >= 160 && keyCode <= 255;
  var controlModifier = altKey || ctrlKey || metaKey;
  var printable = spaceKey || equalKey || numberKey || letterKey || numPadKey || latin1Key;
  return !controlModifier && printable;
}

var SheetControls =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SheetControls, _PureComponent);

  function SheetControls() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SheetControls);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SheetControls)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focusRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focus", function () {
      _this.focusRef.current.focus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBlur", function () {
      document.removeEventListener('copy', _this.onCopy);
      document.removeEventListener('cut', _this.onCut);
      document.removeEventListener('paste', _this.onPaste);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCopy", function () {
      var _this$props = _this.props,
          columns = _this$props.columns,
          rows = _this$props.rows,
          selection = _this$props.selection;

      if (!selection) {
        return;
      }

      var snippet = utils.getSelection(rows, columns, selection);
      utils.copyToClipboard(snippet);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCut", function () {
      var _this$props2 = _this.props,
          columns = _this$props2.columns,
          dispatch = _this$props2.dispatch,
          rows = _this$props2.rows,
          selection = _this$props2.selection;

      if (!selection) {
        return;
      }

      var snippet = utils.getSelection(rows, columns, selection);
      utils.copyToClipboard(snippet);
      dispatch(actions.clearSelection(selection));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFocus", function () {
      document.addEventListener('copy', _this.onCopy);
      document.addEventListener('cut', _this.onCut);
      document.addEventListener('paste', _this.onPaste);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPaste", function (event) {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          readOnly = _this$props3.readOnly;
      var clipboardData = event.clipboardData.getData('text');

      if (!(0, _isNil.default)(clipboardData) && clipboardData !== '' && !readOnly) {
        var snippet = utils.pasteFromClipboard(clipboardData);
        dispatch(actions.insertSnippet(snippet));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onKeyDown", function (event) {
      var selection = _this.props.selection;

      if (!selection) {
        return;
      }

      switch (event.key) {
        case 'ArrowDown':
          _this.handleArrowMove(event, 0, 1);

          return;

        case 'ArrowLeft':
          _this.handleArrowMove(event, -1, 0);

          return;

        case 'ArrowRight':
          _this.handleArrowMove(event, 1, 0);

          return;

        case 'ArrowUp':
          _this.handleArrowMove(event, 0, -1);

          return;

        case 'Backspace':
          _this.handleClear(event);

          return;

        case 'Delete':
          _this.handleClear(event);

          return;

        case 'Enter':
          _this.handleShiftEnterMove(event, 0, 1);

          return;

        case 'Escape':
          _this.handleCancel(event);

          return;

        case 'Tab':
          _this.handleShiftEnterMove(event, 1, 0);

          return;

        default:
          break;
      }

      if (isPrintable(event)) {
        _this.handleEdit();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(SheetControls, [{
    key: "handleCancel",
    value: function handleCancel(event) {
      var _this$props4 = this.props,
          dispatch = _this$props4.dispatch,
          editing = _this$props4.editing;

      if (utils.isEditing(editing)) {
        dispatch(actions.cancelActiveCell());
        event.preventDefault();
      }
    }
  }, {
    key: "handleClear",
    value: function handleClear(event) {
      var _this$props5 = this.props,
          dispatch = _this$props5.dispatch,
          editing = _this$props5.editing,
          selection = _this$props5.selection,
          readOnly = _this$props5.readOnly;

      if (!selection) {
        return;
      }

      if (!utils.isEditing(editing) && !readOnly) {
        dispatch(actions.clearSelection(selection));
        event.preventDefault();
      }
    }
  }, {
    key: "handleEdit",
    value: function handleEdit() {
      var _this$props6 = this.props,
          dispatch = _this$props6.dispatch,
          editing = _this$props6.editing,
          readOnly = _this$props6.readOnly;

      if (!utils.isEditing(editing) && !readOnly) {
        dispatch(actions.editActiveCell(''));
      }
    }
  }, {
    key: "handleArrowMove",
    value: function handleArrowMove(event, deltaX, deltaY) {
      var _this$props7 = this.props,
          dispatch = _this$props7.dispatch,
          editing = _this$props7.editing;

      if (utils.isEditing(editing)) {
        return;
      }

      if (event.shiftKey) {
        dispatch(actions.resizeSelection(deltaX, deltaY));
      } else {
        dispatch(actions.moveSelection(deltaX, deltaY, false));
      }

      event.preventDefault();
    }
  }, {
    key: "handleShiftEnterMove",
    value: function handleShiftEnterMove(event, deltaX, deltaY) {
      var dispatch = this.props.dispatch;
      var invertDirection = event.shiftKey ? -1 : 1;
      dispatch(actions.moveSelection(invertDirection * deltaX, invertDirection * deltaY, true));
      event.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          children = _this$props8.children,
          style = _this$props8.style; // We need to work on browser accessibility. For now, turn of ESLint.

      /* eslint-disable jsx-a11y/no-static-element-interactions */

      return _react.default.createElement("div", {
        className: containerStyle,
        ref: this.focusRef,
        role: "grid",
        style: style,
        tabIndex: 0,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        onKeyDown: this.onKeyDown
      }, children);
      /* eslint-enable jsx-a11y/no-static-element-interactions */
    }
  }]);
  return SheetControls;
}(_react.PureComponent);

exports.default = SheetControls;
(0, _defineProperty2.default)(SheetControls, "propTypes", {
  children: _propTypes.default.node,
  columns: _propTypes.default.arrayOf(shapes.column).isRequired,
  dispatch: _propTypes.default.func.isRequired,
  editing: shapes.editing.isRequired,
  rows: _propTypes.default.arrayOf(shapes.row).isRequired,
  selection: shapes.selection,
  style: _propTypes.default.objectOf(_propTypes.default.any),
  readOnly: _propTypes.default.bool.isRequired
});